module.exports = __webpack_public_path__ + "assets/25621d1a866aacbad5948b77b509f394.png";